import type { MemberDetail } from '@riverpark/types'

export function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

export function formatMemberSince(createdAt: number): string {
  return new Date(createdAt * 1000).toLocaleDateString('en-KE', {
    month: 'long',
    year: 'numeric',
  })
}

export type ProfileTabId = 'overview' | 'billing' | 'plots' | 'settings' | 'activity'

export function getAvailableTabs(
  profile: MemberDetail,
  options?: { includeSettings?: boolean; includeBilling?: boolean },
): ProfileTabId[] {
  const includeSettings = options?.includeSettings ?? true
  const includeBilling = options?.includeBilling ?? false
  const tabs: ProfileTabId[] = ['overview']
  if (includeBilling) {
    tabs.push('billing')
  }
  if (profile.role !== 'admin' && profile.role !== 'estate_manager') {
    tabs.push('plots')
  }
  if (includeSettings) {
    tabs.push('settings')
  }
  tabs.push('activity')
  return tabs
}

export function getProfileTabLabel(tab: ProfileTabId, isSelf: boolean): string {
  switch (tab) {
    case 'overview':
      return 'Overview'
    case 'billing':
      return 'Billing'
    case 'plots':
      return 'Plots'
    case 'settings':
      return isSelf ? 'Edit profile' : 'Manage'
    case 'activity':
      return 'Activity'
  }
}
